import { SectionA } from '../../oasis-sections/section-a';
import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { isActive } from '../util';
export const sectionASkipPatterns = ({ input, ctx, version, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
    }
    else if (!field) {
        // section level
        const payload = input;
        if (isActive(SectionA.a2120, version, payload?.m0100) && isActive(SectionA.a2122, version, payload?.m0100)) {
            // A-skip pattern-5760 (a) If A2120=[0,2], then all active items from A2122A through A2122E must equal [^].
            if (payload?.a2120 && ['0', '2'].includes(payload.a2120) && payload?.a2122?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-5760 (a) If A2120 = 0 or 2, then all items in A2122 from A through E must NOT be checked.',
                    path: ['a2120'],
                });
            }
            //  A-skip pattern-5760 (b) If A2120=[1], then all active items from A2122A through A2122E must not equal [^].
            if (payload?.a2120 && ['1'].includes(payload.a2120) && !payload?.a2122?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-5760 (b) If A2120 = 1, then A2122 must NOT be empty.',
                    path: ['a2122'],
                });
            }
            //  A-skip pattern-5760 (c) If A2120=[1], then at least one active item from A2122A through A2122E must equal [1].
            if (payload?.a2120 && ['1'].includes(payload.a2120) && !payload?.a2122?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-5760 (c) If A2120 = 1, then at least one item in A2122 from A through E must be checked.',
                    path: ['a2122'],
                });
            }
        }
        if (isActive(SectionA.a2121, version, payload?.m0100) && isActive(SectionA.a2122, version, payload?.m0100)) {
            //  A-skip pattern-5750 (a) If A2121=[0], then all active items from A2122A through A2122E must equal [^].
            if (payload?.a2121 === '0' && payload.a2122?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-5750 (a) If A2121 = 0, then all items in A2122 from A through E must NOT be checked.',
                    path: ['a2121'],
                });
            }
            //  A-skip pattern-5750 (b) If A2121=[1], then all active items from A2122A through A2122E must not equal [^].
            if (payload?.a2121 === '1' && !payload.a2122?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '5750 (b) If A2121 = 1, then A2122 must NOT be empty.',
                    path: ['a2122'],
                });
            }
            //  A-skip pattern-5750 (c) If A2121=[1], then at least one active item from A2122A through A2122E must equal [1].
            if (payload?.a2121 === '1' && !payload.a2122?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-5750 (c) If A2121 = 1, then at least one item in A2122 from A through E must be checked.',
                    path: ['a2122'],
                });
            }
        }
        if (isActive(SectionA.m1000, version, payload?.m0100) && isActive(SectionA.m1005, version, payload?.m0100)) {
            // A-skip pattern-4921 If M1000_DC_NONE_14_DA=[1], then M1005_INP_DISCHARGE_DT and M1005_INP_DSCHG_UNKNOWN must equal [^].
            if (payload?.m1000 && payload.m1000.includes('DC_NONE_14_DA') && (payload.m1005 || payload.m1005NA)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `-4921 If NA is selected in M1000, then M1005 and 'Inpatient discharge date unknown' in M1005 must be empty.`,
                    path: ['m1005'],
                });
            }
        }
        if (isActive(SectionA.m2420, version, payload?.m0100) &&
            (isActive(SectionA.a2121, version, payload?.m0100) || isActive(SectionA.a2122, version, payload?.m0100))) {
            // A-skip pattern-5770 If M2420_DSCHRG_DISP=[01,04,UK], then all active items from A2121 through A2122E must equal [^].
            if (payload?.m2420 && ['01', '04', 'UK'].includes(payload.m2420) && (payload.a2121 || payload.a2122?.length)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-5770 If M2420 = 01, 04, or UK, then items in A2121 and all items in A2122 from A to E must NOT be checked.',
                    path: ['m2420'],
                });
            }
            // A-skip pattern-6190 If M2420_DSCHRG_DISP =[02,03], then A2121 must not equal [^].
            if (payload?.m2420 && ['02', '03'].includes(payload.m2420) && !payload.a2121) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-6190 If M2420 = 02 or 03, then A2121 must NOT be empty.',
                    path: ['a2121'],
                });
            }
            // A-skip pattern-7000 If M2420_DSCHRG_DISP = [01,04,UK], then A2123 must not equal [^].
            if (payload?.m2420 && ['01', '04', 'UK'].includes(payload.m2420) && !payload.a2123) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-7000 If M2420 = 01, 04, or UK, then A2123 must NOT be empty.',
                    path: ['a2123'],
                });
            }
            // A-skip pattern-7010 If M2420_DSCHRG_DISP = [02,03], then all active items from A2123 through A2124E must equal [^].
            if (payload?.m2420 && ['02', '03'].includes(payload.m2420) && (payload.a2123?.length || payload.a2124?.length)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-7010 If M2420 = 02 or 03, then items in A2123 and A2124 from A to E must NOT be checked.',
                    path: ['m2420'],
                });
            }
        }
        if (isActive(SectionA.m2301, version, payload?.m0100) && isActive(SectionA.m2310, version, payload?.m0100)) {
            // A-skip pattern-4531 If M2301_EMER_USE_AFTR_LAST_ASMT=[00,UK], then all active items from M2310_ECR_MEDICATION through M2310_ECR_UNKNOWN must equal [^].
            if (payload?.m2301 && ['00', 'UK'].includes(payload.m2301) && payload.m2310?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-4531 If M2301 = 00 or UK, then all items in M2310 must NOT be checked',
                    path: ['m2301'],
                });
            }
            // A-skip pattern-4541 If M2301_EMER_USE_AFTR_LAST_ASMT=[01,02], then all active items from M2310_ECR_MEDICATION through M2310_ECR_UNKNOWN must not equal [^]."
            if (payload?.m2301 && ['01', '02'].includes(payload.m2301) && !payload.m2310?.length) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: '-4541 If M2301 = 01 or 02, then M2310 must NOT be empty.',
                    path: ['m2310'],
                });
            }
        }
    }
    else {
        // field level
    }
};
// A-skip pattern-5760
// (a) If A2120=[0,2], then all active items from A2122A through A2122E must equal [^].
// (b) If A2120=[1], then all active items from A2122A through A2122E must not equal [^].
// (c) If A2120=[1], then at least one active item from A2122A through A2122E must equal [1].
// A-skip pattern-5750
// (a) If A2121=[0], then all active items from A2122A through A2122E must equal [^].
// (b) If A2121=[1], then all active items from A2122A through A2122E must not equal [^].
// (c) If A2121=[1], then at least one active item from A2122A through A2122E must equal [1].
// A-skip pattern-5770 If M2420_DSCHRG_DISP=[01,04,UK], then all active items from A2121 through A2122E must equal [^].
// A-skip pattern-6190 If M2420_DSCHRG_DISP =[02,03], then A2121 must not equal [^].
// A-skip pattern-7000 If M2420_DSCHRG_DISP = [01,04,UK], then A2123 must not equal [^].
// A-skip pattern-7010 If M2420_DSCHRG_DISP = [02,03], then all active items from A2123 through A2124E must equal [^].
// A-skip pattern-4511 ***THIS EDIT WAS DELETED IN V3.01.0***
// A-skip pattern-4521 ***THIS EDIT WAS DELETED IN V3.01.0***
// A-skip pattern-4921 If M1000_DC_NONE_14_DA=[1], then M1005_INP_DISCHARGE_DT and M1005_INP_DSCHG_UNKNOWN must equal [^].
// A-skip pattern-4531 If M2301_EMER_USE_AFTR_LAST_ASMT=[00,UK], then all active items from M2310_ECR_MEDICATION through M2310_ECR_UNKNOWN must equal [^].
// A-skip pattern-4541 If M2301_EMER_USE_AFTR_LAST_ASMT=[01,02], then all active items from M2310_ECR_MEDICATION through M2310_ECR_UNKNOWN must not equal [^]."
